import { Box, TextField, Typography } from "@mui/material";
import { addCommas } from "@persian-tools/persian-tools";
import React, { ChangeEvent } from "react";

interface Props {
  handleChangeInput: (e: ChangeEvent<HTMLInputElement>) => void;
  name: string;
  value: string;
  error?: boolean | string;
}

export default function PriceInput(props: Props) {
  const { handleChangeInput, name, value, error } = props;
  return (
    <Box
      sx={{
        borderRadius: "10px",
        borderColor: error ? "error.main" : "info.main",
        borderWidth: error ? "2px" : "1px",
        borderStyle: "solid",
        backgroundColor: "info.light",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <TextField
        type="search"
        name={name}
        value={value}
        onChange={handleChangeInput}
        placeholder="-----"
        autoComplete="off"
        inputProps={{
          inputMode: "numeric",
          pattern: "[1-9]*",
        }}
        sx={{
          textAlign: "left",
          direction: "ltr",
          flex: 1,
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none !important",
            outline: "none !important",
          },
          "& .MuiInputBase-input": {
            //   border: "none !important",
            outline: "none !important",
          },
          "& .MuiInputBase-root": {
            border: "none !important",
            outline: "none !important",
          },
          border: "none",
        }}
      />
      <Typography width={"45%"}>ریال</Typography>
    </Box>
  );
}
